import { CommonCheckbox, CommonDateRange, CrossButton, CustomPagination, CustomSelect } from 'components'
import React, { useContext, useEffect, useMemo, useState } from 'react';
import moment from "moment";
import './invoiceLrToLrTdsPayment.css'
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5';
import { StorageServices } from 'utils';
import { supplierTripListApi } from '_services/accountsServices/supplierServices';
import { UserContext } from 'context';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { getAllVehicleNumber, handleKeyDown } from '_services';
import { addPaymentLrToLrInvoiceDetails, addTdsPercentageLrToLrInvoiceDetails, createPaymentInvoiceDetails, createTdsInvoiceDetails } from '_services/invoiceBillRaiseServices';

const InvoiceLrToLrTdsPayment = (props) => {
    let { isOpen, onClose, previousModal, callInvoiceDetailsApi, billRaiseDetailsData } = props;
    const [isLoading, setIsLoading] = useState(false)
    const [supplierLrList, setSupplierLrList] = useState([])

    const supplierTripPayHandle = async (data) => {
        const payload = {
            company_id: isOpen?.company_id,
            billraise_id: isOpen?.billraise_id,
            tds_percentage: isOpen?.tds_percentage?.value,
        }

        try {
            setIsLoading(true)
            const res = await addTdsPercentageLrToLrInvoiceDetails(payload)
            if (res?.responseCode == 200) {
                setSupplierLrList(res?.data)
                setIsLoading(false)
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (isOpen) {
            supplierTripPayHandle()
        }
    }, [isOpen])

    const onCloseHandler = () => {
        onClose(false);
        previousModal(isOpen);
    }

    const handleOnChangeCheck = (lrId, name, value) => {
        if (name === 'is_checked') {
            setSupplierLrList(prevState => {
                const updatedLrList = prevState.lr_list.map(lr => {
                    if (lr._id === lrId) {
                        return {
                            ...lr,
                            [name]: value
                        };
                    }
                    return lr;
                });

                const totalTdsAmount = updatedLrList.reduce((sum, lr) => {
                    return sum + (lr?.is_checked ? (lr?.lr_freight?.total_tds || 0) : 0);
                }, 0);

                return {
                    ...prevState,
                    lr_list: updatedLrList,
                    total_tds_amount: totalTdsAmount
                };
            });
        }
    }

    // Handle TDS % change
    const handleTdsPercentageChange = (lrId, name, value, maxAmount) => {
        // Handle empty value
        if (value === '') {
            updateLrTdsData(lrId, name, '');
            return;
        }

        if (name === 'tds_deduction') {
            // For TDS deduction percentage - allow decimals
            const numValue = value.replace(/[^0-9.]/g, '');

            // Prevent multiple decimal points
            const parts = numValue.split('.');
            if (parts.length > 2) {
                return; // Don't update if more than one decimal point
            }

            if (numValue === '') {
                updateLrTdsData(lrId, name, '');
                return;
            }

            // Allow partial input like "14." while typing
            if (numValue.endsWith('.') && parts.length === 2 && parts[1] === '') {
                updateLrTdsData(lrId, name, numValue);
                return;
            }

            const tdsPercentage = parseFloat(numValue);

            // Check if it's a valid number and within reasonable percentage (0-100)
            if (!isNaN(tdsPercentage) && tdsPercentage >= 0 && tdsPercentage <= 100) {
                updateLrTdsData(lrId, name, numValue); // Pass the string value to preserve decimals
            }
        } else {
            // For total_tds amount - allow decimals
            const numValue = value.replace(/[^0-9.]/g, '');

            // Prevent multiple decimal points
            const parts = numValue.split('.');
            if (parts.length > 2) {
                return; // Don't update if more than one decimal point
            }

            if (numValue === '') {
                updateLrTdsData(lrId, name, '');
                return;
            }

            // Allow partial input like "88." while typing
            if (numValue.endsWith('.') && parts.length === 2 && parts[1] === '') {
                updateLrTdsData(lrId, name, numValue);
                return;
            }

            const tdsAmount = parseFloat(numValue);

            // Check if it's a valid number and within max amount
            if (!isNaN(tdsAmount) && tdsAmount <= maxAmount) {
                updateLrTdsData(lrId, name, numValue); // Pass the string value to preserve decimals
            }
        }
    }

    const updateLrTdsData = (lrId, name, value) => {
        setSupplierLrList(prevState => {
            const updatedLrList = prevState.lr_list.map(lr => {
                if (lr._id === lrId) {
                    let totalFreight;
                    let calculatedTds;
                    let remainingBalance;
                    let calculateTdsdeduction;
                    if (name === 'tds_deduction') {
                        totalFreight = lr.lr_freight.total_freight || 0;

                        if (value === '') {
                            // When clearing tds_deduction, also clear total_tds
                            calculatedTds = '';
                            remainingBalance = lr.lr_freight.balance;
                            calculateTdsdeduction = '';
                        } else {
                            const tdsPercentage = parseFloat(value);
                            calculatedTds = (totalFreight * tdsPercentage) / 100;
                            remainingBalance = lr.lr_freight.balance - calculatedTds;
                            calculateTdsdeduction = value; // Keep as string to preserve decimal input
                        }
                    } else {
                        totalFreight = lr.lr_freight.total_freight || 0;

                        if (value === '') {
                            // When clearing total_tds, also clear tds_deduction
                            calculatedTds = '';
                            remainingBalance = lr.lr_freight.balance;
                            calculateTdsdeduction = '';
                        } else {
                            const tdsAmount = parseFloat(value);
                            calculatedTds = value; // Keep as string to preserve decimal input
                            remainingBalance = lr.lr_freight.balance - tdsAmount;
                            calculateTdsdeduction = totalFreight === 0
                                ? ''
                                : ((tdsAmount / totalFreight) * 100).toFixed(2);
                        }
                    }

                    return {
                        ...lr,
                        lr_freight: {
                            ...lr.lr_freight,
                            tds_deduction: calculateTdsdeduction,
                            total_tds: calculatedTds,
                            remaining_balance: remainingBalance
                        }
                    };
                }
                return lr;
            });

            // Recalculate total TDS amount
            const totalTdsAmount = updatedLrList.reduce((sum, lr) => {
                const tdsValue = lr?.is_checked ? (lr?.lr_freight?.total_tds || 0) : 0;
                return sum + (typeof tdsValue === 'string' ? parseFloat(tdsValue) || 0 : tdsValue);
            }, 0);

            return {
                ...prevState,
                lr_list: updatedLrList,
                total_tds_amount: totalTdsAmount
            };
        });
    }

    const listLrForApi = useMemo(() => {
        return supplierLrList?.lr_list?.filter((el) => Number(el?.is_checked) === 1 && Number(el?.lr_freight?.tds_deduction > 0))?.map((item) => {
            return {
                lr_id: item?._id,
                lr_number: item?.lr_number,
                trip_id: item?.trip_id?._id,
                trip_number: item?.trip_id?.trip_number,
                tds_deduction: item?.lr_freight?.tds_deduction,
                total_tds: item?.lr_freight?.total_tds
            }
        })
    }, [supplierLrList])

    const onSubmitExpense = async () => {
        setIsLoading(true);
        try {
            const payload = {
                company_id: isOpen?.company_id,
                billraise_id: isOpen?.billraise_id,
                consignor_id: billRaiseDetailsData?.consignor_id?._id,
                date: new Date(),
                description: "",
                amount: supplierLrList?.total_tds_amount?.toString(),
                lrs: listLrForApi,
            };
            const res = await createTdsInvoiceDetails(payload);
            if (res?.responseCode === 200) {
                setIsLoading(false);
                onClose(false);
                callInvoiceDetailsApi();
            } else {
                setIsLoading(false);
            }
        } catch {
            setIsLoading(false);
        }
        // try {
        // const payload = {
        //     ...isOpen,
        //     tds_percentage: isOpen?.tds_percentage?.value,
        //     lrs: listLrForApi,
        // };
        //     const res = await createPaymentInvoiceDetails(payload);
        //     if (res?.responseCode === 200) {
        //         setIsLoading(false);
        // onClose(false);
        // callInvoiceDetailsApi();
        //     } else {
        //         setIsLoading(false);
        //     }
        // } catch {
        //     setIsLoading(false);
        // }
    };

    return (
        <>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title"> Select LR for TDS Deduction </h5>
                <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={(e) => onCloseHandler(e)}>
                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path
                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                            fill="black" />
                    </svg>
                </CrossButton>
            </div>

            <div className="offcanvas-body">
                <div className='__supsAdd_bg'>
                    <div className='__addPayTable_bx'>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '1%' }}><div></div></th>
                                    <th><div>LR Date</div></th>
                                    <th><div>LR Number</div></th>
                                    <th><div>Trip Number</div></th>
                                    <th><div>Invoice number</div></th>
                                    <th style={{ width: '8%' }}><div>From Station</div></th>
                                    <th style={{ width: '8%' }}><div>To Station</div></th>
                                    <th>Total Freight</th>
                                    <th style={{ width: '10%' }}>TDS %</th>
                                    <th>TDS Deduction</th>
                                    <th style={{ width: '10%' }}>Balance Amount</th>
                                    <th style={{ width: '8%' }}> Remaining Amount</th>
                                </tr>
                            </thead>
                            {supplierLrList?.lr_list?.length > 0 ? supplierLrList?.lr_list?.map((itemLr) => {
                                return (
                                    <tbody className='__pdTd_bxs' key={itemLr._id}>
                                        <tr className={`__paySclIn_bx ${itemLr?.payment_status === 'Full Payment' ? '__fulPay_bxs' : itemLr?.payment_status === 'Partial Payment' ? '__partialPay_bxs' : '__totalPay_bxs'}`}>
                                            <td>
                                                {/* <div
                                                    className={itemLr?.lr_freight?.tds_deduction > 0 ? '__chkPYap' : '__disable_chkPYap'}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {itemLr?.lr_freight?.tds_deduction > 0 ? <IoCheckbox /> : <IoSquareOutline />}
                                                </div> */}
                                                <div className='test_cners'>
                                                    <input
                                                        type="checkbox"
                                                        id={itemLr._id}
                                                        checked={itemLr?.is_checked === true}
                                                        disabled={!(itemLr?.lr_freight?.balance > 0) || (itemLr?.tds_status === 'Already Deducted')}
                                                        onChange={({ target: { name, checked } }) => {
                                                            handleOnChangeCheck(itemLr._id, 'is_checked', checked)
                                                        }}
                                                    />
                                                    <label htmlFor={itemLr._id}>
                                                        <span className="_invisibleSpan">.</span>{" "}
                                                    </label>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    {moment(itemLr?.dispatch_date).format('DD/M/YYYY') || ""}
                                                </div>
                                            </td>
                                            <td>
                                                <div className=''>
                                                    {itemLr?.lr_number || '-'}
                                                </div>
                                            </td>
                                            <td>
                                                <div>{itemLr?.trip_id?.trip_number || '-'}</div>
                                            </td>
                                            <td>
                                                <div>{itemLr?.invoice_number || '-'}</div>
                                            </td>
                                            <td>
                                                <div className='_locationWid_bx'>
                                                    <p className="_tblText">{itemLr?.from_location}</p>
                                                    <p className="_lgtText">
                                                        {itemLr?.unit_id?.name}
                                                    </p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='_locationWid_bx'>
                                                    <p className="_tblText">{itemLr?.to_location}</p>
                                                    <p className="_lgtText">
                                                        {itemLr?.consignee_id?.name}
                                                    </p>
                                                </div>
                                            </td>
                                            <td style={{whiteSpace:'nowrap'}}>
                                                ₹ {itemLr?.lr_freight?.total_freight ? itemLr?.lr_freight?.total_freight?.toFixed(2) : 0}
                                            </td>
                                            <td>
                                                <div className='__sPay_input_new'>
                                                    <input
                                                        type="text"
                                                        name='tds_deduction'
                                                        disabled={!itemLr?.is_checked}
                                                        maxLength={12}
                                                        onKeyDown={handleKeyDown}
                                                        value={itemLr?.lr_freight?.tds_deduction || ''}
                                                        onChange={(e) => handleTdsPercentageChange(itemLr._id, 'tds_deduction', e.target.value)}
                                                        placeholder="1 or 2"
                                                        style={{
                                                            cursor: itemLr?.is_checked ? 'text' : 'not-allowed',
                                                            opacity: itemLr?.is_checked ? 1 : 0.6
                                                        }}
                                                    />
                                                    <span style={{ marginLeft: '5px', display: 'flex', alignItems: 'center' }}>%</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='__sPay_input_new'>
                                                    <input
                                                        type="text"
                                                        name='total_tds'
                                                        disabled={!itemLr?.is_checked}
                                                        maxLength={12}
                                                        onKeyDown={handleKeyDown}
                                                        value={itemLr?.lr_freight?.total_tds || ''}
                                                        onChange={(e) => handleTdsPercentageChange(itemLr._id, 'total_tds', e.target.value, itemLr?.lr_freight?.balance)}
                                                        placeholder="₹"
                                                        style={{
                                                            cursor: itemLr?.is_checked ? 'text' : 'not-allowed',
                                                            opacity: itemLr?.is_checked ? 1 : 0.6
                                                        }}
                                                    />
                                                </div>
                                                {/* ₹ {itemLr?.lr_freight?.total_tds ? itemLr?.lr_freight?.total_tds?.toFixed(2) : 0} */}
                                            </td>
                                            <td>
                                                <div className='__mainPaid_bxs'>
                                                    <div style={{whiteSpace:'nowrap'}}>₹ {itemLr?.lr_freight?.balance?.toFixed(2) || '0.00'}</div>
                                                    {itemLr?.tds_status === 'TDS Deducted' && (
                                                        <div className='__trpDeliver_stats'>{itemLr?.tds_status}</div>
                                                    )}
                                                    {itemLr?.tds_status === 'Not Applicable' && (
                                                        <div className='__no_pay_pod_stats'>{itemLr?.tds_status}</div>
                                                    )}
                                                    {(itemLr?.tds_status !== 'Not Applicable' && itemLr?.tds_status !== 'TDS Deducted') && (
                                                        <div className='__pod_stats'>{itemLr?.tds_status}</div>
                                                    )}
                                                </div>
                                            </td>
                                            <td style={{whiteSpace:'nowrap'}}>
                                                ₹ {itemLr?.lr_freight?.remaining_balance ? itemLr?.lr_freight?.remaining_balance?.toFixed(2) : 0}
                                            </td>
                                        </tr>
                                    </tbody>
                                );
                            }) : <tbody className='__pdTd_bxs'>
                                <tr className={`__paySclIn_bx __partialPay_bxs`}>
                                    <td>
                                        Loading...
                                    </td>
                                </tr>
                            </tbody>
                            }
                        </table>
                    </div>
                </div>
            </div>
            <div className='offcanvas-footer' style={{ display: 'flex', justifyContent: "space-between" }}>
                <div style={{ display: 'flex', gap: "10px" }}>
                    <button
                        className='_addComm_btn _sameResWid'
                        onClick={() => {
                            onSubmitExpense(supplierLrList?.lr_list)
                        }}
                        disabled={isLoading || !(supplierLrList?.total_tds_amount > 0) || !(supplierLrList?.lr_list?.some((el) => el?.is_checked === true))}
                        style={{
                            cursor: (isLoading || !(supplierLrList?.total_tds_amount > 0) || !(supplierLrList?.lr_list?.some((el) => el?.is_checked === true))) ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isLoading ? 'Loading...' : 'Deduct TDS'}
                    </button>
                    <button
                        className='_cancel_btn'
                        onClick={(e) => onCloseHandler(e)}
                    >
                        Cancel
                    </button>
                </div>
                <span className='bottomBgLine'>
                    ₹ {supplierLrList?.total_tds_amount ? supplierLrList?.total_tds_amount?.toFixed(2) : 0} Total TDS Deducted
                </span>
            </div>
        </>
    )
}

export default InvoiceLrToLrTdsPayment